import React, { useEffect, useRef, useState } from "react";
import qs from "qs";
import axios from "axios";
import get from "lodash/get";
import config from "../../config";
import ModulesActions from "modules/entity/actions";
import getMenu from "./getMenu";
import getMenuMain from "./getMenuMain";
import { useDispatch, useSelector } from "react-redux";
import Actions from "store/actions";
import getMainOrganizationMenu, {
	getTechCardMenu
} from "./getMainOrganizationMenu";
import "./style.scss";
import { Grid } from "antd";
import useTranslation from "../../hooks/useTranslation";
import { useLocation } from "react-router-dom";
import classNames from "classnames";
import NewLogo from "assets/images/new-logo.png";
import { Link } from "react-router-dom";
import { Icon } from "components/Layout/icons/Icon";
import { NewHeader } from "components/Layout/Header/new-header";
import { Lock, LogOut, MenuIcon, Search, X } from "lucide-react";
import { SidebarMenuButton } from "./sidebar-item";
import { NavLink } from "react-router-dom";
import { helpers, storage } from "services/index";
import OutsideClick from "hooks/OutsideClick";
import Avatar from "assets/images/svg/avatar6.svg";
import { Button } from "components/Button/Button";
import { matchPath } from "react-router-dom";
import { Field } from "formik";
import { SidebarModal, FakeInputs } from "components";
import EntityForm from "modules/entity/forms";
import { Fields } from "uicomponents";
import useAlert from "hooks/useAlert";
import Maintenance from "pages/Maintenance";
import SuggestionButton from "components/SuggestionButton";

const { useBreakpoint } = Grid;

const Layout = props => {
	const { tr } = useTranslation();
	const { showAlert } = useAlert();
	const [searchText, setSearchText] = useState("");
	const [isOpen, setIsOpen] = useState(false);
	const [passwordModalOpen, setPasswordModalOpen] = useState(false);
	const { children } = props;
	const profile = useSelector(state => state.auth.user);
	const screen = useBreakpoint();
	const { ref, isVisible, setIsVisible } = OutsideClick();
	const location = useLocation();
	const maintenanceMode = useSelector(state => state.auth.maintenance_mode);

	const isComingsViewPage = location.pathname.startsWith("/storage/comings/");
	const isMaintenancePage = !!maintenanceMode;

	const activeMenuId = useRef("");

	const [openMenuId, setOpenMenuId] = useState("");

	function toggleMenu(id) {
		setOpenMenuId(openMenuId === id ? "" : id);
	}

	useEffect(() => {
		try {
			const matchedMenu = (menu || []).find(m => {
				return (m.children || []).some(subMenu => {
					const matched = matchPath(
						{ path: subMenu.link },
						location.pathname
					);

					return matched;
				});
			});

			if (matchedMenu) {
				toggleMenu(matchedMenu.id);
				activeMenuId.current = matchedMenu.id;
			}
		} catch (error) {
			console.log("--- useEffect Layout ---", error);
		}
	}, []);

	const activeOrganization = get(profile, "organization");
	const balance = Number(
		get(activeOrganization, "balance", 0) ? activeOrganization.balance : 0
	);

	const selected_organization = useSelector(
		state => state.auth.selected_organization
	);
	const isMainOrganization = useSelector(
		state => state.auth.is_main_organization
	);

	const isTechCardOrganization =
		String(config.TECH_CARD_ORGANIZATION_ID) ===
		String(get(selected_organization, "id"));

	const is_main = get(selected_organization, "is_main", 0) === 1;
	const dispatch = useDispatch();
	const prevPathnameRef = useRef(location.pathname);

	useEffect(() => {
		if (prevPathnameRef.current === location.pathname) return;
		prevPathnameRef.current = location.pathname;
		dispatch(Actions.auth.SetMaintenanceMode.request(false));
	}, [location.pathname]);

	function fetchTranslations() {
		const queryString = qs.stringify(
			{
				filter: {
					type: 1
				},
				per_page: 1000
			},
			{
				encode: false,
				arrayFormat: "brackets"
			}
		);
		axios
			.get(`${config.API_ROOT}/translations/client/get?${queryString}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("token")}`
				}
			})
			.then(function (response) {
				dispatch(Actions.system.SetTranslations.trigger(response.data));
			})
			.catch(function (error) {
				console.error("Error fetching translations:", error);
			})
			.finally(function () { });
	}
	const loadClientLanguages = () => {
		dispatch(
			ModulesActions.LoadDefault.request({
				url: "/languages/client/get",
				cb: {
					success: data => {
						const storedLanguage = localStorage.getItem("language");
						const langTypes = data.data;
						const currentLang =
							langTypes.find(lang => lang.code === storedLanguage) ||
							langTypes.find(lang => lang.is_main);
						dispatch(Actions.system.SetLangCodes.trigger(langTypes));
						dispatch(Actions.system.ChangeLanguage.trigger(currentLang.code));
					},
					error: data => { }
				}
			})
		);
	};

	useEffect(() => {
		fetchTranslations();
		loadClientLanguages();
	}, []);

	const menu = (() => {
		if (isMainOrganization)
			return getMainOrganizationMenu(get(profile, "role.role"));
		if (is_main) return getMenuMain(get(profile, "role.role"));
		if (isTechCardOrganization) return getTechCardMenu();
		return getMenu(profile.roles);
	})();

	const headerRef = useRef(null);

	const headerHeight = headerRef.current ? headerRef.current.offsetHeight : 80;

	return (
		<div className="min-h-full bg-primary-dark">
			<div className="devent-content hidden" />

			<div
				className="sticky top-0 w-full bg-primary-dark h-14 md:h-16 lg:h-20 | flex items-center !z-50"
				ref={headerRef}
			>
				<div className="tw-sidebar-w h-full p-3 relative">
					<Link
						to="/"
						className="hover:bg-white/10 h-full p-3 rounded-xl active:scale-95 duration-300 inline-flex items-center justify-center"
					>
						<img src={NewLogo} alt="logo" className="h-full object-contain" />
					</Link>
				</div>

				<header className="tw-body-w h-full !px-3 relative | flex items-center">
					<NewHeader />
				</header>
			</div>

			<main className="flex min-h-full">
				<div className="tw-sidebar-w | flex-col bg-primary-dark">
					<div
						className="sticky top-0 p-2 text-white | flex flex-col h-[calc(100vh-80px)]"
						style={{ top: headerHeight }}
					>
						<div className="!relative text-[#B2CCFF]">
							<input
								className="bg-gray-50/10 border-none h-10 px-3 w-full rounded-md !pl-10 placeholder:text-[#B2CCFF]"
								placeholder={tr("Поиск")}
								value={searchText}
								onChange={e => setSearchText(e.currentTarget.value)}
							/>

							<Search className="absolute start-0 ps-3 inset-y-0 top-1 peer-disabled:opacity-50 size-8 pointer-events-none" />
						</div>
						<div className="flex-grow py-5 text-white overflow-y-auto scrollable--hidden">
							<div className="flex flex-col gap-2">
								{searchText ? (
									<>
										{(menu || [])
											.flatMap(m => m.children || [])
											.filter(subMenu => {
												return subMenu.label
													.toLowerCase()
													.includes(searchText.toLowerCase());
											})
											.map(subMenu => {
												return (
													<NavLink
														key={subMenu.link}
														className={({ isActive }) => {
															return classNames({
																"text-sm flex items-center gap-3 group text-[#D1E0FF] hover:text-white hover:bg-[#00359E] rounded-md select-none cursor-pointer duration-200 h-10 px-3": true,
																"!text-white !bg-[#00359E]": isActive,
																"!cursor-not-allowed pointer-events-none opacity-50":
																	subMenu.isLocked
															});
														}}
														to={subMenu.link}
														onClick={() => setSearchText("")}
													>
														<div className="flex items-center gap-4 select-none cursor-pointer duration-200 h-10 pr-3 pl-8">
															{subMenu.isLocked ? (
																<Lock
																	className={classNames({
																		"ml-auto text-[#84ADFF] duration-150 size-4": true
																	})}
																/>
															) : null}
															<div>{tr(subMenu.label)}</div>
														</div>
													</NavLink>
												);
											})}
									</>
								) : (
									<>
										{menu.map(m => {
											const IconRender = m.NewIcon ? (
												<m.NewIcon
													className="size-5 text-[#84ADFF] flex-shrink-0"
													strokeWidth={2}
												/>
											) : (
												<Icon icon={m.icon} />
											);

											if (m.link) {
												return (
													<NavLink
														key={m.link}
														end
														className={({ isActive }) =>
															classNames({
																"flex items-center gap-3 group text-[#D1E0FF] hover:text-white hover:bg-[#00359E] rounded-md select-none cursor-pointer duration-200 h-10 px-3": true,
																"!text-white !bg-[#00359E]": isActive
															})
														}
														to={m.link}
														onClick={() => {
															setOpenMenuId("");
															activeMenuId.current = "";
														}}
													>
														{IconRender}

														<div>{tr(m.label)}</div>
													</NavLink>
												);
											}

											return (
												<React.Fragment key={m.id}>
													<SidebarMenuButton
														isLocked={m.isLocked}
														icon={IconRender}
														title={m.label}
														isOpen={openMenuId === m.id}
														isActive={activeMenuId.current === m.id}
														onClick={() => toggleMenu(m.id)}
													/>
													<div
														className="grid transition-[grid-template-rows] duration-300 ease-in-out"
														style={{ gridTemplateRows: openMenuId === m.id ? "1fr" : "0fr" }}
													>
														<div className="overflow-hidden">
															<div className="flex flex-col gap-1 pb-1">
																{(m.children || []).map(subMenu => {
																	return (
																		<NavLink
																			key={subMenu.link}
																			className={({ isActive }) => {
																				return classNames({
																					"text-sm flex items-center gap-3 group text-[#D1E0FF] hover:text-white hover:bg-[#00359E] rounded-md select-none cursor-pointer duration-200 h-10 px-3": true,
																					"!text-white !bg-[#00359E]":
																						isActive &&
																						location.pathname.concat(
																							location.search
																						) === subMenu.link,
																					"!cursor-not-allowed pointer-events-none opacity-50":
																						subMenu.isLocked
																				});
																			}}
																			to={subMenu.link}
																			onClick={() => {
																				activeMenuId.current = m.id;
																			}}
																		>
																			<div className="flex items-center gap-4 select-none cursor-pointer duration-200 h-10 pr-3 pl-8">
																				{subMenu.isLocked ? (
																					<Lock
																						className={classNames({
																							"ml-auto text-[#84ADFF] duration-150 size-4": true
																						})}
																					/>
																				) : null}

																				<div>{tr(subMenu.label)}</div>
																			</div>
																		</NavLink>
																	);
																})}
															</div>
														</div>
													</div>
												</React.Fragment>
											);
										})}
									</>
								)}
							</div>
						</div>

						<div className="py-5" style={{ borderTop: "2px solid #0040c1" }}>
							<div className="flex justify-between items-center ">
								<div
									onClick={() => setPasswordModalOpen(true)}
									className="flex justify-start items-center flex-grow gap-3 hover:bg-gray-100/10 rounded-md p-1 cursor-pointer"
								>
									<div className="size-10 flex items-center justify-center">
										<img src="/favicon.png" alt="" className="h-full w-full" />
									</div>

									<div className="flex flex-col gap-1 justify-start items-start relative">
										<p className="text-sm my-0 font-semibold text-left text-white">
											{get(profile, "name")}
										</p>
										<p className="text-xs my-0 text-left text-[#b2ccff]">
											{activeOrganization.name}
										</p>
									</div>
								</div>
								<div
									onClick={() => {
										storage.remove("token");
										window.location.reload();
									}}
									className="flex justify-center items-center rounded-lg | cursor-pointer duration-150 hover:bg-gray-100/10 text-[#84ADFF] p-4"
									title="Chiqish"
								>
									<LogOut size={20} />
								</div>
							</div>
						</div>
					</div>
				</div>

				<div
					className={classNames({
						"tw-body-w bg-[var(--main-bg)] rounded-tl-2xl z-0 w-full relative": true,
						"p-3": !isMaintenancePage,
						"overflow-hidden h-[calc(100vh-56px)] md:h-[calc(100vh-64px)] lg:h-[calc(100vh-80px)]": isMaintenancePage,
						"overflow-x-auto":
							!isMaintenancePage &&
							window.location.pathname !== "/settings/new-settings" &&
							!isComingsViewPage,
						"overflow-x-hidden": isComingsViewPage && !isMaintenancePage
					})}
				>
					{isMaintenancePage ? <Maintenance /> : children}
				</div>
			</main>

			<SidebarModal
				size={500}
				isOpen={passwordModalOpen}
				toggle={() => setPasswordModalOpen(false)}
			>
				<div className="p-5">
					<div className="flex items-center justify-between mb-6">
						<h2 className="text-xl font-bold m-0">{tr("Изменить имя и пароль")}</h2>
						<button
							type="button"
							onClick={e => {
								e.preventDefault();
								e.stopPropagation();
								setPasswordModalOpen(false);
							}}
							className="p-2 hover:bg-gray-100 rounded-md cursor-pointer border-0"
							aria-label="Yopish"
						>
							<X size={20} />
						</button>
					</div>
					<EntityForm.Default
						method="put"
						url="/user/update-me"
						onSuccess={() => {
							showAlert("Успешно сохранено", { type: "success" });
							setPasswordModalOpen(false);
							// window.location.reload();
						}}
						onError={error => {
							const errorMessage = get(error, "errorData.message");
							showAlert(errorMessage || "Xatolik", { type: "danger", delay: 5000 });
						}}
						fields={[
							{ name: "name", value: get(profile, "name") },
							// Faqat password kiritilganda password va confirmation backendga yuboriladi.
							{ name: "password", disabled: values => !get(values, "password") },
							{ name: "password_confirmation", disabled: values => !get(values, "password") }
						]}
						updateData
					>
						{({ isSubmitting, values }) => {
							function validate(stringValue) {
								// Confirmation faqat `password` kiritilganda talab qilinadi.
								const passValue = get(values, "password");

								// Password bo'lmasa confirmation kiritilmagan bo'lsa -> ok
								if (!passValue) {
									// Password bo'sh bo'lsa, confirm kiritilgan bo'lsa ham xatolik qaytaramiz
									// (faqat password kiritishdan foydalanganda ishlashi uchun).
									return stringValue ? tr("Введите новый пароль") : undefined;
								}

								// Password kiritilgan bo'lsa confirmation majburiy
								if (!stringValue) return "Required";

								if (passValue !== stringValue) return tr("Не совпадает пароль");
								return undefined;
							}
							return (
								<div>
									<FakeInputs />
									<Field
										component={Fields.InputS1}
										name="name"
										type="text"
										placeholder={tr("Введите новое имя")}
										label={tr("Новое имя")}
										size="small"
									/>
									<Field
										component={Fields.InputS1}
										name="password"
										type="password"
										placeholder={tr("Введите новый пароль")}
										label={tr("Новый пароль")}
										size="small"
									/>
									<Field
										component={Fields.InputS1}
										name="password_confirmation"
										type="password"
										placeholder={tr("Повторите новый пароль")}
										label={tr("Повторите новый пароль")}
										size="small"
										validate={validate}
									/>
									<button
										type="submit"
										disabled={isSubmitting}
										className={`d-btn--small d-btn d-btn-primary d-btn--full ${isSubmitting ? "--loading" : ""}`}
									>
										{tr("Сохранить")}
									</button>
								</div>
							);
						}}
					</EntityForm.Default>
				</div>
			</SidebarModal>
			<SuggestionButton />
		</div>
	);
};

export default Layout;